export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  price: number;
  currency: string;
  mode: 'payment' | 'subscription';
}

export const STRIPE_PRODUCTS: StripeProduct[] = [
  {
    id: 'prod_TfDjqEyvnzrbnz',
    priceId: 'price_1ShtIPAjCPmtPuihXVxTJRVW',
    name: 'Your Personalized Recommendations',
    description: 'Personalized tool stack.',
    price: 29.00,
    currency: 'usd',
    mode: 'payment'
  }
];

export const formatPrice = (price: number, currency: string = 'usd'): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(price);
};

export const getProductByPriceId = (priceId: string): StripeProduct | undefined => {
  return STRIPE_PRODUCTS.find(product => product.priceId === priceId);
};